import { Component, inject, input, signal } from '@angular/core';
import { Router } from '@angular/router';
import { LocationBasic } from '../../../types';

@Component({
  selector: 'app-transactions-tab',
  templateUrl: './transactions-tab.component.html',
  styleUrls: ['./transactions-tab.component.scss'],
  standalone: false,
})
export class TransactionsTabComponent {
  private router = inject(Router);

  public locationId = input<number>();

  public selectedLocation = signal<LocationBasic | undefined>(undefined);

  updateLocationData() {
    if (!this.selectedLocation()) return;

    const id = this.selectedLocation().id;

    if (id !== +this.selectedLocation()) {
      this.router.navigate(['/home', 'transactions', id], {
        queryParamsHandling: 'merge',
      });
    }
  }
}
